import http from '../http'

export default {
  show: async () => {
    const { data } = await http.get('/api/private/v1/drafts')
    return data.data
  },
  store: async (params) => {
    await http.post('/api/private/v1/drafts', { params, type: 'campaign' })
  },
  update: async (draftId, params) => {
    await http.put(`/api/private/v1/drafts/${draftId}`, params)
  }
}
